import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/academic-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/academic1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/accept_star.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/accept-circle-blue-small.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Accept-icon-rounded.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Accept.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/ad-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Arrow-down.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/arrow-right-black.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Arrow-right-blue.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/arrow-right-circle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Arrow-right-white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/article-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/bank-blue.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Bank-tatement-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/black_star.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/book-group1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/book-group2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/book-group3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/book-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/brochure_bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/brochure_hero_group1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/brochure-use1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/brochure-use2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/brochure-use3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/business-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/cad-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/capabilities-customer.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/capabilities-hr.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/capabilities-immigration.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/capabilities-localization.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/capabilities-professional.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/capabilities-scientific.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/capabilities-technical.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/carbon_delivery-parcel.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/circle_flag1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/circle_flag2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/circle-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/circle-certified.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/circle-flag-en.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/circle-flag-green.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/clinical-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/compilance-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/contract-blank-left.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/contract-blank-right.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-hero-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-logo1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-logo2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-logo3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-logo4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-logo5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-logo6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-small.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-translators5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/customer-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/death-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/diploma-green-flag.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/diploma-hero.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/elearning-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/elearning-hero.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/email-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/email-hero-blank.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/email-shield-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/enterprice-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/film-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/film-blank1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/film-blank2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-hero-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-logo-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-report-blank.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-report-circle-dollar.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-report-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-statement-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-statement-hero-blank1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-statement-hero-blank2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-translators5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/financial-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/flowbite_language-outline.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/game-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/game-hero-blank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/gg_loadbar-doc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/gm.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Group_1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Group_2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Group_3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/handbook-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/handbook-hero-blank.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-hero-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-logo-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-small.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-translators5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/hr-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/immigration_translators1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/immigration-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/immigration-tranlsators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/immigration-tranlsators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/immigration-tranlsators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/immigration-tranlsators5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/immigration-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/industries-see-all.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/invoice-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/invoice-blank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/invoice-shield.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/knowledge-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/la_certificate.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/label-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/label-blank1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/label-blank2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card7.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card8.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/language-documents-card9.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/legal-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/Letter-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/license-hero-blank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/linkedin-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-hero-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-small.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-translators5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/localization-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/lock.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/man.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/manual-blank1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/manual-blank2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/manual-hero-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/marketing-small.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/marketing-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/marriage-blank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-capabilities.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-hero-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-logo1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-logo2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-logo3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-logo4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-logo5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/medical-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/mortgage-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/order_calendar.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/order_logo_group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/order_message.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/packaging-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/passport-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/passport-blank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/patent-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/patent-blank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/patent-shield.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/pdf-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/pen-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/presentation-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/product-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/professional-logo-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/professional-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/professional-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/professional-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/professional-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/professional-translators5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/protect_logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/provide1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/provide2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/provide3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/reCAPTCHA.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/release-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/research-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/scientific-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/scientific-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/scientific-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/scientific-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/scientific-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/scientific-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/scientific.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/select_arrow_down.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/seo-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/social-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/software-blank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/solar_blank.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/solar_case.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/solar_planet.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/square-confirm.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/standart-translation.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/subtitle-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/support-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/support1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/support2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/support3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/tax-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/tax.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-industries1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-industries2.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-industries3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-industries4.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-industries5.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-logo1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-logo2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-logo3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-logo4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-translators1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-translators2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-translators3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-translators4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-translators5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical-wide.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/technical.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/test-logo-HR.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/test-logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/text-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/ticket-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/trademark-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/transcript-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/transcript-blank1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/transcript-blank2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/use-case-test1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/use-case-test2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/use-case-test3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/use-case-test4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/video-bg.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/video-blank1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/video-blank2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/visa-group.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/woman.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/assets_second/youtube-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/excellence/Excellence.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/industry/Industry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/language/Language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/home/blocks/Advantages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/home/blocks/HeroBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/home/blocks/ServiceOfferings.tsx");
